<template>
  <div>
    <template>
      <div>
        <div class="main-sidebar">
          <p class="create-card">{{$t('panel.createCardPanel.modalTitle')}}</p>

          <label class="card-description">
          {{this.$t('panel.createCardPanel.modal')}}
          </label>

          <label class="label-text">{{$t('panel.createCardPanel.cardTitle')}}</label>
          <input
            style="border-radius: 30px;"
            class="form-control"
            v-model="title"
          />
          <p v-if="!isValid" style="color: red; margin: 0; font-size: 15px;">
            {{$t('panel.createCardPanel.homePageCard.title')}}
          </p>

          <label class="label-text">{{this.$t('panel.createCardPanel.metric')}}</label>
          <b-form-select
            style="border-radius: 30px;"
            class="form-control"
            v-model="metric"
            :options="optionsMetrics"
          ></b-form-select>

          <label class="label-text">{{this.$t('panel.createCardPanel.type')}}</label>

          <b-dropdown
            squared
            variant="outline-secondary"
            class="btn-block"
            menu-class="p-2"
            no-caret
          >
            <template slot="button-content">
              <span style="float: left; font-size: 1rem;">
                {{
                  selectedAnalysis ? selectedAnalysis : $t('panel.createCardPanel.formTextArea.chooseAnalysis')
                }}
              </span>
            </template>
            <b-dropdown-item
              href="#"
              v-for="(item, i) in optionsAnalysis"
              :key="i"
              @click="setAnalysysis(item)"
            >
              <span class="string--formater-drop" :title="item.text">
                {{ item.text }}
              </span>
            </b-dropdown-item>
          </b-dropdown>

          <label class="label-text">{{this.$t('panel.createCardPanel.reportName')}}</label>
          <b-form-select
            class="form-control"
            v-model="selectedReport"
            :options="optionsReports"
            style="border-radius: 30px;"
          ></b-form-select>

          <label class="label-text">{{$t('panel.createCardPanel.timeChoise')}}</label>
          <div style="display: flex;">
            <b-form-select
              class="form-control"
              v-model="selectedPeriod"
              :options="optionsPeriod"
              style="border-radius: 30px;"
            ></b-form-select>
            <vc-date-picker
              mode="range"
              :popover="{
                placement: $screens({ default: 'bottom', md: 'left-start' }),
              }"
              v-model="dates"
              color="green"
            >
              <font-awesome-icon
                :icon="['fas', 'calendar-alt']"
                class="ml-2 calendar-icon"
                style="font-size: 18px; margin-top: 10px;"
              />
            </vc-date-picker>
          </div>

          <template
            v-if="
              dates && dates.start && dates.end && selectedPeriod === 'Personalizado'
            "
          >
            <label>Período: {{ returnDates(dates) }}</label>
            <br />
          </template>

          <label class="label-text">{{$t('panel.createCardPanel.chooseFilterTitle')}}</label>
          <b-form-select
            class="form-control"
            v-model="filterGroup"
            :options="optionsGroup"
            style="border-radius: 30px;"
          ></b-form-select>

          <template v-if="filterGroup === 'Grupo de ações'">
            <label class="label-text">{{$t('panel.createCardPanel.formTextArea.chooseFilterDescription')}}</label>

            <b-dropdown
              variant="outline-secondary"
              class="btn-block"
              menu-class="w-100 p-2"
              no-caret
            >
              <template slot="button-content">
                <span style="float: left;" class="button--formater2">
                  {{ groupAction ? groupAction.name : $t('panel.createCardPanel.filterOptions.actionGroupName') }}
                </span>
              </template>
              <input
                type="text"
                class="form-control mb-2"
                v-model="actionGroupFilter"
              />
              <b-dropdown-item
                href="#"
                v-for="(group, i) in allGroups"
                :key="i"
                @click="setActionGroup(group)"
              >
                <span class="string--formater" :title="group.name">
                  {{ group.name }}
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <template v-if="filterGroup === 'Ação'">
            <label class="label-text">{{$t('panel.createCardPanel.filterOptions.chooseActionTitle')}}</label>
            <b-dropdown
              variant="outline-secondary"
              class="btn-block panel"
              menu-class="w-100 p-2"
              no-caret
            >
              <template slot="button-content">
                <span style="float: left;" class="button--formater2">
                  {{ action ? action.name : $t('panel.createCardPanel.filterOptions.action') }}
                </span>
              </template>
              <input
                type="text"
                class="form-control mb-2"
                v-model="actionFilter"
              />
              <b-dropdown-item
                href="#"
                v-for="(item, i) in actions"
                :key="i"
                @click="setValAction(item)"
              >
                <span class="string--formater" :title="item.name">
                  {{ item.name }}
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <template v-if="filterGroup === 'Filial'">
            <label class="label-text">Escolha a filial</label>

            <b-dropdown
              variant="outline-secondary"
              class="btn-block"
              menu-class="w-100 p-2"
              no-caret
            >
              <template slot="button-content">
                <span class="button--formater">
                  {{ branch.length > 0 ? `${branch[0].corporate_name} ${branch.length > 1 ? `+ ${branch.length - 1}` : ''}` : $t('panel.createCardPanel.filterOptions.filial') }}
                </span>
              </template>
              <input
                type="text"
                class="form-control mb-2"
                v-model="branchFilter"
              />
              <b-dropdown-item
                href="#"
                v-for="(item, i) in branchs"
                :key="i"
                @click="setValBranch(item)"
              >
                <span class="string--formater" :title="item.corporate_name">
                  {{ item.corporate_name }}
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <template v-if="filterGroup === 'Indicador'">
            <label class="label-text">Escolha o indicador</label>

            <b-dropdown
              squared
              variant="outline-secondary"
              class="btn-block"
              menu-class="w-100 p-2"
              no-caret
            >
              <template slot="button-content">
                <span class="button--formater2">
                  {{ indicator ? indicator.text : $t('panel.createCardPanel.filterOptions.indicator') }}
                </span>
              </template>
              <input
                type="text"
                class="form-control mb-2"
                v-model="indicatorFilter"
                @keypress.enter="setIndicator(indicator)"
              />
              <b-dropdown-item
                href="#"
                v-for="(indicator, i) in getIndicatorsPaginate()"
                :key="i"
                @click="setIndicator(indicator)"
              >
                <span class="string--formater" :title="indicator.text">
                  <div class="list">
                    <div class="list-element">{{ indicator.text }}</div>
                  </div>
                </span>
              </b-dropdown-item>
              <button id="loadmore" class="btn-loadmore" @click="loadMore">
                <p> {{this.$t('panel.createCardPanel.panelHeader.loadMore')}}</p>
              </button>
            </b-dropdown>

            <template v-if="indicator">
              <label class="label-text">{{ $t('panel.createCardPanel.editCard.chooseValueIndicator') }}</label>

              <div v-if="!isDateIndicator(indicator)">
                <b-dropdown
                  variant="outline-secondary"
                  class="btn-block"
                  menu-class="w-100"
                  no-caret
                >
                  <template slot="button-content">
                    <span class="button--formater2">
                      <!-- {{ checkIndicatorData() }} -->

                      {{
                        valueIndicator
                          ? valueIndicator.text
                          : $t('panel.createCardPanel.filterOptions.chooseIndicatorValue')
                      }}
                    </span>
                  </template>
                  <input
                    type="text"
                    class="form-control mb-2"
                    v-model="indicatorValueFilter"
                  />
                  <b-dropdown-item
                    href="#"
                    v-for="(item, i) in getIndicatorsValuePaginate()"
                    :key="i"
                    @click="handleIndicatorData(item)"
                  >
                    <span class="string--formater" :title="item.text">
                      {{ item.text }}
                    </span>
                  </b-dropdown-item>
                  <button
                    id="loadmore-indic-value"
                    class="btn-loadmore"
                    @click="loadMoreIndicValue"
                  >
                  {{this.$t('panel.createCardPanel.panelHeader.loadMore')}}
                  </button>
                </b-dropdown>
              </div>
            </template>
          </template>

          <div v-if="indicator && valueIndicator">

            <template v-if="arrayIndicators.length > 0">
                <div
                    v-for="(item, index) in arrayIndicators"
                    :key="index"
                    class="tags-array"
                  >
                    <span >
                      {{ item.key }}:
                      {{ item.value }}
                    </span>
                    <span @click="removeFilterIndicator(index)" class="remove"
                      >&times;</span
                    >
                </div>
            </template>
          </div>

          <div v-if="branch.length > 0">
            <div class="tag" v-for="(item, branchIndex) in branch" :key="branchIndex">
                <span>
                  {{$t('panel.createCardPanel.homePageCard.branch')}}:
                  {{ item.corporate_name }}
                </span>
                <span @click="removeFilter('branch', branchIndex)" class="remove">&times;</span>
            </div>
          </div>

          <div v-if="action" class="tag">
            <span>
              {{ $t('panel.createCardPanel.homePageCard.action') }}
              {{ action.name }}
            </span>
            <span @click="removeFilter('action')" class="remove">&times;</span>
          </div>

          <div v-if="groupAction" class="tag">
            <span>
              {{ $t('panel.createCardPanel.homePageCard.actionGroup') }}
              {{ groupAction.name }}
            </span>
            <span @click="removeFilter('groupAction')" class="remove"
              >&times;</span
            >
          </div>

          <template v-if="selectedReport">
            <label class="label-text"
              >{{ $t('panel.createCardPanel.editCard.chooseTypeGraph') }}
            </label>

            <div style="display: flex; margin-top: 10px;">
              <button
                @click="onSlideEnd"
                style="
                  font-size: 30px;
                  background: #fff;
                  border: none;
                  outline: 0;
                  color: #5e5e5e;
                "
              >
                <font-awesome-icon :icon="['fas', 'angle-left']" />
              </button>

              <b-carousel
                id="carousel-1"
                v-model="slide"
                background="#fff"
                :interval="0"
                style="text-shadow: 1px 1px 2px #333; border: 2px dotted #333;"
              >
                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Análise por dispositivo'"
                  :img-src="analyzeDevice"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de sentimento'"
                  :img-src="evolutionSentimentArea"
                >
                </b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de sentimento'"
                  :img-src="evolutionSentimentBar"
                >
                </b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de sentimento'"
                  :img-src="evolutionSentimentLine"
                >
                </b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Classificação de sentimento'"
                  :img-src="sentimentGraph"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Classificação de sentimento'"
                  :img-src="sentiment"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Categorias'"
                  :img-src="categories"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Comparativo de ação'"
                  :img-src="comparativeActions"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de ações'"
                  :img-src="evolutionActions"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de convites'"
                  :img-src="evolutionInvitesArea"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de convites'"
                  :img-src="evolutionInvitesBar"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de convites'"
                  :img-src="evolutionInvitesLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="
                    selectedReport === 'Evolução de nps' ||
                    selectedReport === 'Evolução de ces' ||
                    selectedReport === 'Evolução de csat' ||
                    selectedReport === 'Evolução de Five Stars' ||
                    selectedReport === 'Evolução like/dislike'
                  "
                  :img-src="evolutionNps"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="
                    selectedReport === 'Evolução de nps' ||
                    selectedReport === 'Evolução de ces' ||
                    selectedReport === 'Evolução de csat' ||
                    selectedReport === 'Evolução de Five Stars' ||
                    selectedReport === 'Evolução like/dislike'
                  "
                  :img-src="evolutionNpsArea"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="
                    selectedReport === 'Evolução de nps' ||
                    selectedReport === 'Evolução de ces' ||
                    selectedReport === 'Evolução de csat' ||
                    selectedReport === 'Evolução de Five Stars' ||
                    selectedReport === 'Evolução like/dislike'
                  "
                  :img-src="evolutionNpsLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de percentuais'"
                  :img-src="evolutionNpsLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Nuvem de palavras'"
                  :img-src="cloudWord"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Ranking like/dislike'"
                  :img-src="likeDislike"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Score de sentimento'"
                  :img-src="scoreSentiment"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Indicador de sentimento'"
                  :img-src="indicatorSentiment"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Top 5 keywords'"
                  :img-src="topKeywords"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Conversão'"
                  :img-src="conversion"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Ranking multipla escolha'"
                  :img-src="multiple"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Ranking likert'"
                  :img-src="likert"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Relatório de mapa'"
                  :img-src="map"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Ranking nps'"
                  :img-src="nps"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Ranking Ces 1 a 5'"
                  :img-src="ces"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Ranking emotion'"
                  :img-src="emotion"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Ranking escala 0 a 10'"
                  :img-src="csat"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Ranking review'"
                  :img-src="review"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Detratores recorrentes'"
                  :img-src="recurringDetractor"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Resposta por canais'"
                  :img-src="questionByChannel"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Status de tratativas'"
                  :img-src="statusTreatments"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Tags de tratativas'"
                  :img-src="tagsTreatments"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Monitoramento de pesquisa'"
                  :img-src="surveyInvites"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Análise de indicador'"
                  :img-src="indicadorAnalyze"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de respostas'"
                  :img-src="evolutionAnswerArea"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de respostas'"
                  :img-src="evolutionAnswerBar"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução de respostas'"
                  :img-src="evolutionAnswerLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução like/dislike'"
                  :img-src="evolutionLikeDislikeArea"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução like/dislike'"
                  :img-src="evolutionLikeDislikeBar"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Evolução like/dislike'"
                  :img-src="evolutionLikeDislikeLine"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Indice Nps' ||
                    selectedReport === 'Indice Ces' ||
                    selectedReport === 'Indice Csat' ||
                    selectedReport === 'Indice Like/Dislike' ||
                    selectedReport === 'Indice Five Stars'"
                  :img-src="index"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Nps-Percentual' ||
                    selectedReport === 'Ces-Percentual' ||
                    selectedReport === 'Csat-Percentual' ||
                    selectedReport === 'Like/Dislike-Percentual' ||
                    selectedReport === 'Five Stars-Percentual'"
                  :img-src="percentage"
                ></b-carousel-slide>

                <b-carousel-slide
                  style="padding: 50px;"
                  v-if="selectedReport === 'Distribuição de notas'"
                  :img-src="gradeDistribution"
                ></b-carousel-slide>
              </b-carousel>

              <button
                @click="onSlideStart"
                style="
                  font-size: 30px;
                  background: #fff;
                  border: none;
                  color: #5e5e5e;
                  outline: 0;
                "
              >
                <font-awesome-icon :icon="['fas', 'angle-right']" />
              </button>
            </div>

            <center>
              <p>Gráficos {{ slide + 1 }}</p>
              <!-- {{ slide + 1 }} / 16 -->
            </center>
          </template>

          <template footer>
            <div class="pb-4" style="padding-left: 55%; margin-top: 15px;">
              <div>
                <b-button variant="outline-primary" @click="cancel"
                  >Cancelar</b-button
                >
                <b-button variant="primary" @click="saveCard">Salvar</b-button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { lightFormat } from 'date-fns';
import swal from 'sweetalert';
import imgUseTemplate from '../../../assets/use-template.jpg';
import imgMakePanel from '../../../assets/make-panel.jpg';
import analyzeDevice from '../../../assets/analise-dispositivo.png';
import analyzeSentiment1 from '../../../assets/analise-sentimento-1.png';
import sentimentGraph from '../../../assets/classificacao-sentimento-grafico.png';
import sentiment from '../../../assets/classificacao-sentimento.png';
import analyzeSentiment3 from '../../../assets/analise-sentimento-3.png';
import analyzeSentiment4 from '../../../assets/analise-sentimento-4.png';
import analyzeSentiment5 from '../../../assets/analise-sentimento-5.png';
import evolutionSentimentArea from '../../../assets/evolucao-sentimento-area.png';
import evolutionSentimentBar from '../../../assets/evolucao-sentimento-barras.png';
import evolutionSentimentLine from '../../../assets/evolucao-sentimento-linhas.png';
import conversion from '../../../assets/conversao.png';
import indicatorSentiment from '../../../assets/indicador-sentimento.png';
import topKeywords from '../../../assets/top5-keywords.png';
import categories from '../../../assets/categorias.png';
import comparativeActions from '../../../assets/comparativo-ações.png';
import evolutionActions from '../../../assets/evolução-ações.png';
import evolutionInvites from '../../../assets/evolução-convites.png';
import evolutionNps from '../../../assets/evolução-nps.png';
import evolutionNpsArea from '../../../assets/evolução-nps-area.png';
import evolutionNpsLine from '../../../assets/evolução-nps-linha.png';
import evolutionPercentage from '../../../assets/evolução-percentuais.png';
import questionByChannel from '../../../assets/pergunta-canais.png';
import scoreSentiment from '../../../assets/score-sentimento.png';
import emotion from '../../../assets/emotion.png';
import cloudWord from '../../../assets/nuvem-palavras.png';
import recurringDetractor from '../../../assets/detratores-recorrentes.png';
import addQuestion from '../../../assets/pergunta-adicional.png';
import statusTreatments from '../../../assets/status-tratativas.png';
import csat from '../../../assets/escala0a10-csat.png';
import ranking from '../../../assets/ranking-pergunta-adicional.png';
import likeDislike from '../../../assets/like-dislike-panel.png';
import review from '../../../assets/review.png';
import ces from '../../../assets/addquestion-ces.png';
import likert from '../../../assets/addquestion-likert.png';
import tagsTreatments from '../../../assets/tags-tratativas.png';
import indicadorAnalyze from '../../../assets/analise-indicador.png';
import map from '../../../assets/relatorio-mapa.png';
import nps from '../../../assets/addquestion-nps.png';
import multiple from '../../../assets/multipla-escolha.png';
import surveyInvites from '../../../assets/monitoramento-pesquisa.png';
import evolutionInvitesBar from '../../../assets/evolucao-convites-bar.png';
import evolutionInvitesArea from '../../../assets/evolucao-convites-area.png';
import evolutionInvitesLine from '../../../assets/evolucao-convites-line.png';
import evolutionAnswerBar from '../../../assets/evolucao-respostas-barra.png';
import evolutionAnswerArea from '../../../assets/evolucao-respostas-area.png';
import evolutionAnswerLine from '../../../assets/evolucao-respostas-linha.png';
import evolutionLikeDislikeBar from '../../../assets/evolucao-like-dislike-barra.png';
import evolutionLikeDislikeArea from '../../../assets/evolucao-like-dislike-area.png';
import evolutionLikeDislikeLine from '../../../assets/evolucao-like-dislike-linha.png';
import index from '../../../assets/indice.png';
import percentage from '../../../assets/percentual.png';
import gradeDistribution from '../../../assets/distribuicao-notas.png';
import api from '../../../services/api';
import modalAddTemplateDefault from '../modal-add-template';

export default {
  name: 'ModalAddPanels',
  props: {
    // idPanel: {
    //   type: String,
    // },
  },
  components: {
    modalAddTemplateDefault,
  },
  computed: {
    ...mapState('panels', ['panelsInfo', 'showSidebar', 'panel', 'idPanel']),
    ...mapFields('profiles', ['profiles']),
    ...mapFields('actions', ['allGroups']),
    ...mapState('branches', ['ih1', 'ih2']),
  },
  data: () => ({
    disabledCustom: true,
    disabledDefault: true,
    modalPanel: null,
    // showSidebar: null,
    imgUseTemplate,
    imgMakePanel,
    optionsReports: [],
    optionsAnalysis: [],
    selectedReport: null,
    selectedAnalysis: null,
    selectedPeriod: null,
    slide: 0,
    sliding: null,
    title: '',
    description: '',
    perfils: [],
    userAuth: null,
    allAnalysesTypes: null,
    filterGroup: null,
    optionsGroup: [],
    groupAction: null,
    action: null,
    branch: [],
    indicators: null,
    valuesIndicator: [],
    indicator: null,
    valueIndicator: null,
    metric: null,
    optionsMetrics: [
      {
        value: null,
        text: 'Selecione a métrica',
      },
      {
        value: 'nps-0-10',
        text: 'NPS - escala 0 a 10',
      },
      {
        value: 'nps-1-5',
        text: 'NPS - escala 1 a 5',
      },
      {
        value: 'ces-1-5',
        text: 'CES - escala 1 a 5',
      },
      {
        value: 'csat-1-5',
        text: 'CSAT - escala 1 a 5(Top 2 box)',
      },
      {
        value: 'csat-1-5(media)',
        text: 'CSAT - escala 1 a 5(media)',
      },
      {
        value: '5-stars',
        text: '5-Stars',
      },
      {
        value: 'like-dislike',
        text: 'Like/Dislike 0 e 1',
      },
    ],
    limit: 20,
    limitValue: 20,
    indicatorsFilterValue: [],
    actionFilter: null,
    indicatorFilter: null,
    actionGroupFilter: null,
    branchFilter: null,
    indicatorValueFilter: null,
    graph: null,
    dates: {
      start: null,
      end: +new Date(),
      selected: 'Personalizado',
    },
    dateStartEnd: null,
    period: null,
    analyzeDevice,
    analyzeSentiment1,
    analyzeSentiment3,
    analyzeSentiment4,
    analyzeSentiment5,
    evolutionSentimentArea,
    evolutionSentimentBar,
    evolutionSentimentLine,
    indicatorSentiment,
    questionByChannel,
    categories,
    comparativeActions,
    evolutionActions,
    evolutionInvites,
    evolutionNps,
    evolutionPercentage,
    evolutionNpsArea,
    conversion,
    evolutionNpsLine,
    recurringDetractor,
    scoreSentiment,
    statusTreatments,
    sentimentGraph,
    topKeywords,
    sentiment,
    cloudWord,
    addQuestion,
    tagsTreatments,
    emotion,
    map,
    ranking,
    review,
    likeDislike,
    evolutionInvitesBar,
    evolutionInvitesLine,
    evolutionInvitesArea,
    evolutionAnswerBar,
    evolutionAnswerArea,
    evolutionAnswerLine,
    evolutionLikeDislikeBar,
    evolutionLikeDislikeArea,
    evolutionLikeDislikeLine,
    csat,
    ces,
    likert,
    indicadorAnalyze,
    nps,
    multiple,
    surveyInvites,
    allIndicators: null,
    allActionGroup: null,
    allActionData: null,
    actions: null,
    branchs: null,
    allActions: null,
    isValid: true,
    index,
    percentage,
    gradeDistribution,
    arrayIndicators: [],
    auxIndicatorName: null,
    limitIndicatorValue: 20,
  }),
  methods: {
    ...mapActions('profiles', ['getProfiles']),
    ...mapActions('panels', [
      'setPanelsInfo',
      'setShowSidebar',
      'setCreateCardPanel',
      'getAllPanels',
    ]),
    ...mapActions('actions', ['getAllActions']),
    returnDates(dates) {
      const start = lightFormat(new Date(dates.start), 'dd/MM/yyyy');
      const end = lightFormat(new Date(dates.end), 'dd/MM/yyyy');
      return `${start} a ${end}`;
    },
    async cancel() {
      await this.setShowSidebar(false);
    },
    removeFilterIndicator(i){
      this.arrayIndicators.splice(i, 1);
    },
    removeFilter(value, index) {
      if (value === 'indicator') {
        this.indicatorValue = null;
        this.indicator = null;
      } else if (value === 'branch') {
        this.branch.splice(index, 1);
      } else if (value === 'action') {
        this.action = null;
      } else if (value === 'groupAction') {
        this.groupAction = null;
      }
    },
    handleIndicatorData(item) {
      this.valueIndicator = item;
      this.auxIndicatorName = this.indicator.text;
      this.arrayIndicators.push({
        key: this.indicator.text,
        value: item.text
      })
    },
    loadMoreIndicValue() {
      this.limitIndicatorValue = this.limitIndicatorValue + 20;
    },
    getIndicatorsValuePaginate() {
      let indicators;
      if (this.indicatorsFilterValue) {
        // if (this.limitValue >= this.indicatorsFilterValue.length) {
        //   document.querySelectorAll('#loadmore-indic-value').style.display =
        //     'none';
        // } else {
        //   document.querySelectorAll('#loadmore-indic-value').style.display =
        //     'block';
        // }
        indicators = this.indicatorsFilterValue.slice(0, this.limitIndicatorValue);
        // if (indicators.length < 19) {
        //   document.querySelectorAll('#loadmore-indic-value').style.display =
        //     'none';
        // }
      }
      return indicators;
    },
    checkIndicatorData() {
      if (this.indicator) {
        return this.$t('menu.filter.indicators', {
          indicatorData: `${this.indicator.name}`,
        });
      }
      return this.$t('menu.filter.indicatorData');
    },
    isDateIndicator(value) {
      if (this.indicators) {
        for (let i = 0; i < this.indicators.length; i += 1) {
          if (this.indicators[i]._id === value) {
            return true;
          }
        }
      }
      return false;
    },
    async setIndicator(indicator) {
      this.indicator = indicator;
      if(this.auxIndicatorName !== indicator.key){
        this.arrayIndicators = [];
        this.valueIndicator = null;
      }
      const response = await api.get(
        `/filters/indicator-data/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            indicatorValue: indicator.key,
            groupId: null,
            actionId: null,
            ih1: null,
          },
        },
      );
      this.allIndicatorData = response.data;
      this.indicatorsFilterValue = response.data;
    },
    loadMore() {
      this.limit = this.limit + 20;
    },
    getIndicatorsPaginate() {
      let indicators;
      if (this.indicators) {
        if (this.limit >= this.indicators.length) {
          document.querySelector('#loadmore').style.display = 'none';
        } else {
          document.querySelector('#loadmore').style.display = 'block';
        }
        indicators = this.indicators.slice(0, this.limit);
        if (indicators.length < 19) {
          document.querySelector('#loadmore').style.display = 'none';
        }
      }
      return indicators;
    },
    setValBranch(branch) {
      if (!this.branch.includes(branch)) {
        this.branch.push(branch);
      }
    },
    setValAction(action) {
      this.action = action;
    },
    setActionGroup(group) {
      this.groupAction = group;
    },
    setAnalysysis(value) {
      this.selectedAnalysis = value.text;
    },
    onSlideStart() {
      if (this.slide !== this.slide.length - 1) {
        this.slide = this.slide + 1;
      }
    },
    onSlideEnd() {
      if (this.slide !== 0) {
        this.slide = this.slide - 1;
      }
    },
    async saveCard() {
      if (
        this.selectedReport === 'Evolução de nps' ||
        this.selectedReport === 'Evolução de ces' ||
        this.selectedReport === 'Evolução de csat' ||
        this.selectedReport === 'Evolução de Five Stars' ||
        this.selectedReport === 'Evolução like/dislike'
      ) {
        if (this.slide === 0) {
          this.graph = 'column';
        } else if (this.slide === 1) {
          this.graph = 'area';
        } else {
          this.graph = 'line';
        }
      } else if (this.selectedReport === 'Classificação de sentimento') {
        if (this.slide === 0) {
          this.graph = 'graph';
        } else if (this.slide === 1) {
          this.graph = 'card';
        }
      } else if (this.selectedReport === 'Evolução de sentimento') {
        if (this.slide === 0) {
          this.graph = 'area';
        } else if (this.slide === 1) {
          this.graph = 'column';
        } else if (this.slide === 2) {
          this.graph = 'line';
        }
      } else if (this.selectedReport === 'Evolução de convites') {
        if (this.slide === 0) {
          this.graph = 'area';
        } else if (this.slide === 1) {
          this.graph = 'column';
        } else if (this.slide === 2) {
          this.graph = 'line';
        }
      } else if (this.selectedReport === 'Evolução de respostas') {
        if (this.slide === 0) {
          this.graph = 'area';
        } else if (this.slide === 1) {
          this.graph = 'column';
        } else if (this.slide === 2) {
          this.graph = 'line';
        }
      } else if (this.selectedReport === 'Evolução like/dislike') {
        if (this.slide === 0) {
          this.graph = 'area';
        } else if (this.slide === 1) {
          this.graph = 'column';
        } else if (this.slide === 2) {
          this.graph = 'line';
        }
      } else {
        this.graph = 'default';
      }
      let concatValuesIndicators = '';
      if(this.arrayIndicators.length > 0){
        for(let k=0; k < this.arrayIndicators.length; k+=1){
          if(k > 0){
            concatValuesIndicators += `,${this.arrayIndicators[k].value}`;
          }else{
             concatValuesIndicators += `${this.arrayIndicators[k].value}`;
          }
        }
      }
      const cardInfo = {
        idPanel: this.idPanel,
        title: this.title,
        metric: this.metric,
        graph: this.graph,
        typeAnalysis: this.selectedAnalysis,
        report: this.selectedReport,
        period: this.period,
        actionId: this.action,
        actionGroupId: this.groupAction,
        ih1: this.branch,
        indicator: this.indicator,
        valueIndicator: concatValuesIndicators,
        position: {
          w: 1,
          h: 1,
          x: 1,
          y: 1,
          minW: 4,
          minH: 10,
        },
      };
      if (!this.title) {
        this.isValid = false;
        swal({
          title: 'Atenção',
          text: 'Preencha com os campos obrigatórios',
          icon: 'warning',
        });
      } else {
        this.setShowSidebar(false);
        await this.setCreateCardPanel({ token: this.userAuth.token, cardInfo });
        this.indicator = null;
        this.arrayIndicators = [];
        this.title = null;
        this.metric = null;
        this.selectedReport = null;
        this.graph = null;
        this.selectedAnalysis = null;
        this.selectedPeriod = null;
        this.dates = {
          start: null,
          end: +new Date(),
          selected: 'Personalizado',
        };
        this.filterGroup = null;
        this.actionFilter = null;
        this.actionGroupFilter = null;
        this.actionGroup = null;
        this.action = null;
        this.branch = [];
        this.indicatorFilter = null;
        this.indicatorValueFilter = null;
        this.groupAction = null;
        await this.getAllPanels({
          token: this.userAuth.token,
        });
        this.isValid = true;
      }
    },
    openCreateCard() {
      this.$bvModal.hide('modal-create-panel');
    },
    openModalCreatePanel() {
      this.$bvModal.hide('modal-switch-option');
    },
    selectDefault() {
      this.disabledCustom = true;
      this.disabledDefault = false;
      document.getElementById('card-custom').style.background = '#f8f9fa';
      document.getElementById('card-default').style.background = '#fff';
    },
    selectCustomPainel() {
      this.disabledCustom = false;
      this.disabledDefault = true;
      document.getElementById('card-custom').style.background = '#fff';
      document.getElementById('card-default').style.background = '#f8f9fa';
    },
    async getTypeAnalysis() {
      const response = await api.get('get/analysis', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      this.allAnalysesTypes = response.data;
      // response.data.forEach((el) => {
      //   this.optionsAnalysis.push({
      //     value: el.analysisType,
      //     text: el.analysisType,
      //   });
      // });
    },

    async handleIndicator() {
      const response = await api.get(
        `/filters/indicators/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            actionId: this.action === '0' ? null : this.action,
            groupId: this.groupAction,
          },

        },
      );
      this.indicators = response.data.indicators;
      this.allIndicators = response.data.indicators;
    },
    async getDataPanel() {
      if (this.idPanel) {
        const response = await api.get(`/get/panel/${this.idPanel}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            idPanel: this.idPanel,
          },
        });
        this.panel = response.data;
      }
    },
  },
  watch: {

    '$i18n.locale': function watchLocale(lang) {

    },

    filterGroup: function watchFilterGroup() {
      // this.allActionGroup = this.allGroups;
      // this.actions = this.allActions;
      // this.allActionData = this.allActions;
      this.branchs = this.ih1.listFilters;
    },

    branchFilter: function watchBranchFilterih1(value) {
      if (value) {
        this.branchs = this.ih1.listFilters.filter((name) => {
          return name.corporate_name
            .toLowerCase()
            .includes(value.toLowerCase());
        });
      } else {
        this.branchs = this.ih1.listFilters;
      }
    },
    actionFilter: function watchActionFilter(value) {
      if (value) {
        this.actions = this.actions.filter((action) => {
          return action.name.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        this.actions = this.allActionData.data;
      }
    },
    actionGroupFilter: function watchActionGroupFilter(value) {
      if (value) {
        this.allGroups = this.allGroups.filter((group) => {
          return group.name.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        this.allGroups = this.allActionGroup;
      }
    },
    indicatorFilter: function watchIndicatorFilter(value) {
      if (value) {
        this.indicators = this.indicators.filter((indicator) => {
          return indicator.key.toLowerCase().includes(value.toLowerCase());
        });
      } else {
        this.indicators = this.allIndicators;
      }
    },
    indicatorValueFilter: function watchIndicatorValue(value) {
      if (value) {
        this.indicatorsFilterValue = this.indicatorsFilterValue.filter(
          (indicator) => {
            return indicator.key.toLowerCase().includes(value.toLowerCase());
          },
        );
      } else {
        this.indicatorsFilterValue = this.allIndicatorData;
      }
    },
    dates: function watchDates(dates) {
      if(dates){
        const start = lightFormat(new Date(dates.start), 'dd/MM/yyyy');
      const end = lightFormat(new Date(dates.end), 'dd/MM/yyyy');
      this.selectedPeriod = 'Personalizado';
      this.dateStartEnd = `${start} a ${end}`;
      this.period = this.dateStartEnd;
      }
    },
    selectedPeriod: function watchSelectedPeriod(period) {
      this.dateStartEnd = null;
      if (period !== 'Personalizado') {
        this.period = period;
      }
    },
    metric: async function watchMetric(metric) {
    
      this.optionsAnalysis = [];
      this.selectedAnalysis = null;
      this.selectedReport = null;
      this.allActionData = await api.get(
        `/filters/actions/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            type: metric,
          },
        },
      );
      this.allActions = this.allActionData.data;
      this.actions = this.allActionData.data;
      const array = [];
      let others = [];

      for (let i = 0; i < this.allAnalysesTypes.length; i += 1) {
        if (metric === 'nps-0-10' || metric === 'nps-1-5') {
          if (this.allAnalysesTypes[i].metric.indexOf('nps') !== -1) {
            array.push(this.allAnalysesTypes[i]);
          }
        } else if (metric === 'csat-1-5' || metric === 'csat-1-5(media)') {
          if (this.allAnalysesTypes[i].metric.indexOf('csat') !== -1) {
            array.push(this.allAnalysesTypes[i]);
          }
        } else if (metric === 'like-dislike') {
          if (this.allAnalysesTypes[i].metric === 'like-dislike') {
            array.push(this.allAnalysesTypes[i]);
          }
        } else if (this.allAnalysesTypes[i].metric.indexOf(metric) !== -1) {
          array.push(this.allAnalysesTypes[i]);
        }
        if (
          this.allAnalysesTypes[i].analysisType === 'Categorias' ||
          this.allAnalysesTypes[i].analysisType === 'Analise de sentimento' ||
          this.allAnalysesTypes[i].analysisType === 'Perguntas adicionais' ||
         // this.allAnalysesTypes[i].analysisType === 'Indicadores' ||
          this.allAnalysesTypes[i].analysisType === 'Outros'
        ) {
          if(this.allAnalysesTypes[i].analysisType === 'Outros'){
            others = [{text: 'Outros', value: 'Outros'}]
          }else{
            array.push(this.allAnalysesTypes[i]);
          }
        }
      }

      array.forEach((el) => {
        el.reports.forEach((reports, indexReport) => {
          // remove reports
          if(reports.text === 'Detratores recorrentes' ||
             // reports.text === 'Evolução de convites' ||
              reports.text === 'Indicador de sentimento'){
             el.reports.splice(indexReport, 1);
          }
        });

        this.optionsAnalysis.push({
          value: el.analysisType,
          text: this.$i18n.locale === 'br' ? el.analysisType : this.$i18n.locale === 'es' ? el.analysisTypeEs : el.analysisTypeEn,
        });


      });
      this.optionsAnalysis.sort((a,b)=> (a.text > b.text ? 1 : -1))
      this.optionsAnalysis = this.optionsAnalysis.concat(others)
    },
    selectedAnalysis: function watchSelectedAnalysis(value) {


      for (let i = 0; i < this.allAnalysesTypes.length; i += 1) {
        if (this.$i18n.locale === 'br'){
          if (value === this.allAnalysesTypes[i].analysisType) {
          this.optionsReports = this.allAnalysesTypes[i].reports;
        }
      }
         else if (this.$i18n.locale === 'us') {
          if (value === this.allAnalysesTypes[i].analysisTypeEn) {
          this.optionsReports = this.allAnalysesTypes[i].reports;
          // console.log(this.optionsReports)
          }
        }else if (value === this.allAnalysesTypes[i].analysisTypeEs) {
          this.optionsReports = this.allAnalysesTypes[i].reports;
          }
      }
      this.optionsReports.forEach((report) => {
          // remove reports
          if(report.text === 'Tags de tratativas' ||
            report.text === 'Monitoramento de pesquisa'){
            // report.text === 'Conversão'){
            const indexReport = this.optionsReports.findIndex(i => i.text === report.text);

        //   if (this.$i18n.locale === 'br'){
        //  indexReport = this.optionsReports.findIndex(i => i.text === report.text);
        //   } else if (this.$i18n.locale === 'us'){
        //   indexReport = this.optionsReports.findIndex(i => i.text === report.textEn);
        //   }else {
        //   indexReport = this.optionsReports.findIndex(i => i.text === report.textEs);
        //   }

            this.optionsReports.splice(indexReport, 1);
          }
      });
const lang = this.$i18n.locale
    this.optionsReports = this.optionsReports.map(function(item){

    if(lang == "br"){
        const newArray = {
	        text: item.text,
          value: item.text,
	}
        return newArray
    }
    if(lang == "us"){
        const newArray = {
	        text: item.textEn,
          value: item.text,
	}
        return newArray
    }
    if(lang == "es"){
        const newArray = {
	        text: item.textEs,
          value: item.text,
	}
        return newArray
    }
})


     this.optionsReports.sort((a,b)=> (a.value > b.value ? 1 : -1))
    },
    indicator: async function watchValueIndicator(value) {
      const response = await api.get(
        `/filters/indicator-data/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            indicatorValue: value.key,
          },
        },
      );
      this.valuesIndicator = response.data;
    },
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.getTypeAnalysis();
    this.handleIndicator();
    this.allActionGroup = this.allGroups;
    // this.actions = this.allActions;
    this.branchs = this.ih1.listFilters;

    this.optionsMetrics = [
      {
        value: null,
        text: `${this.$t('panel.createCardPanel.metrics.selectMetric')}`
      },
      {
        value: 'nps-0-10',
        text: `${this.$t('panel.createCardPanel.metrics.nps0to10')}`
      },
      {
        value: 'nps-1-5',
        text: `${this.$t('panel.createCardPanel.metrics.nps1to5')}`
      },
      {
        value: 'ces-1-5',
        text: `${this.$t('panel.createCardPanel.metrics.ces1to5')}`
      },
      {
        value: 'csat-1-5',
        text: `${this.$t('panel.createCardPanel.metrics.csat1To5')}`
      },
      {
        value: 'csat-1-5(media)',
        text: `${this.$t('panel.createCardPanel.metrics.csat1To5Media')}`
      },
      {
        value: '5-stars',
        text: `${this.$t('panel.createCardPanel.metrics.fiveStars')}`
      },
      {
        value: 'like-dislike',
        text: `${this.$t('panel.createCardPanel.metrics.likeDislike')}`
      },
    ];

    this.optionsGroup = [
      { value: null, text: `${this.$t('panel.createCardPanel.chooseFilterTitle')}`},
      { value: 'Grupo de ações', text: `${this.$t('panel.createCardPanel.chooseFilter.actionGroup')}`},
      { value: 'Ação', text: `${this.$t('panel.createCardPanel.chooseFilter.action')}`},
      { value: 'Indicador', text: `${this.$t('panel.createCardPanel.chooseFilter.indicator')}`},
      { value: 'Filial', text: `${this.$t('panel.createCardPanel.chooseFilter.filial')}`},
    ];

    this.optionsPeriod = [
      { value: null, text: `${this.$t('panel.createCardPanel.timeChoise')}`},
      { value: 'Hoje', text: `${this.$t('panel.createCardPanel.chooseTime.today')}`},
      { value: 'Ontem', text: `${this.$t('panel.createCardPanel.chooseTime.yesterday')}`},
      { value: 'Ultimos 30 dias', text: `${this.$t('panel.createCardPanel.chooseTime.last30Days')}`},
      { value: 'Mes atual', text: `${this.$t('panel.createCardPanel.chooseTime.currentMonth')}`},
      { value: 'Mes anterior', text: `${this.$t('panel.createCardPanel.chooseTime.lastMonth')}`},
      { value: 'Ano atual', text: `${this.$t('panel.createCardPanel.chooseTime.currentYear')}`},
      { value: 'Ano anterior', text: `${this.$t('panel.createCardPanel.chooseTime.lastYear')}`},
      { value: 'Personalizado', text: `${this.$t('panel.createCardPanel.chooseTime.customized')}`, disabled: true },
    ];
    await this.getProfiles({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
    });
  },
}

</script>

<style lang="scss">
.calendar-icon {
  color: #4ce595;
  cursor: pointer;
  &:hover {
    color: rgb(27, 32, 27);
    ~ .calendar {
      display: block;
    }
  }
}
</style>

<style scoped>
.string--formater-drop {
  display: block;
  font-size: 14px;
  width: 372px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btn-loadmore {
  border: none;
  padding: 10px 20px;
  font-size: 18px;
  cursor: pointer;
  color: #4ce595;
  border-radius: 4px;
  background-color: #fff;
}
.button--formater2 {
  float: left;
}
.button--formater {
  float: left;
}
.tag {
  background: #4ce595;
  padding: 4px 8px;
  color: #fff;
  border-radius: 8px;
  margin-right: 8px;
  min-width: 30%;
  max-width: 80%;
  margin-top: 10px;
}
.tags-array {
  background: #4ce595;
  padding: 4px 8px;
  color: #fff;
  border-radius: 8px;
  margin-right: 8px;
  min-width: 30%;
  max-width: 80%;
  margin-top: 10px;
}
.remove {
  cursor: pointer;
}
.ball-one {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #3db374;
  background-color: #3db374;
}
.ball-two {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #bdbdbd;
  background-color: #bdbdbd;
}
.cards {
  align-items: center;
  justify-content: center;
  display: flex;
  padding-top: 25px;
}
.title-card {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}
.description {
  font-weight: 400;
  font-size: 12px;
  color: #242424;
}
#card-default {
  max-width: 80rem;
  width: 80rem;
  height: 30rem;
}
#card-custom {
  max-width: 80rem;
  width: 80rem;
  background-color: #f8f9fa;
  height: 30rem;
}
.card-img-top {
  padding-top: 40px;
  padding-right: 40px;
  padding-left: 40px;
}
.ball-create-panel {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #3db374;
  background-color: #3db374;
}
.text-create-panel {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  margin-top: 20px;
}
.b-sidebar-outer {
  z-index: 1040;
}
.create-card {
  font-weight: 700;
  font-size: 26px;
  line-height: 28px;
}
.card-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}
.main-sidebar {
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 12px;
  background: #fff;
}
.label-text {
  margin-bottom: 0;
  margin-top: 15px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/add-card/index.vue